const IS_BACKGROUND_REQUESTS_ENABLED = "IS_BACKGROUND_REQUESTS_ENABLED";

export const getIsBackgroundRequestsEnabled = () => {
  return localStorage.getItem(IS_BACKGROUND_REQUESTS_ENABLED) !== "false";
};

export const setIsBackgroundRequestsEnabled = (value) => {
  localStorage.setItem(IS_BACKGROUND_REQUESTS_ENABLED, value);
};



// WEBPACK FOOTER //
// ./src/store/localStorage.js